import { fetchApplications } from '@gn-audio/core/api/knowledge-base';
import { isProductSoftware } from 'src/Shared/utils/is-product-software';
var ApplicationSpotController = (function () {
    function ApplicationSpotController($scope, $q, productContextService) {
        this.$scope = $scope;
        this.$q = $q;
        this.productContextService = productContextService;
    }
    ApplicationSpotController.prototype.$onInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            _this.$scope.group = group;
            _this.$scope.isProductSoftware = isProductSoftware(group);
            _this.$scope.isElementFullWidth = _this.isElementFullWidth();
            if (!group) {
                _this.$scope.applications = [];
                return;
            }
            _this.$q.when(fetchApplications(group.groupId))
                .then(function (applications) { _this.$scope.applications = applications || []; });
        });
        this.$scope.responsive = [{ breakpoint: 567, settings: { slidesToShow: 1, slidesToScroll: 1 } }];
    };
    ApplicationSpotController.prototype.isElementFullWidth = function () {
        return this.$scope.isProductSoftware && !this.$scope.hasHtmlForSoftware
            || !this.$scope.isProductSoftware && !this.$scope.hasHtmlForRegularProduct;
    };
    ApplicationSpotController.$inject = ['$scope', '$q', 'productContextService'];
    return ApplicationSpotController;
}());
export { ApplicationSpotController };
